import { View } from 'backbone.marionette';
import template from './templates/index.jst';
import streak_template from './templates/streak_template.jst';
import streak_pre_season_template from './templates/streak_pre_season_template.jst';
import './index.styl';

const start_round_streak = process.env.START_ROUND_STREAK;

export class EmptyCompRowView extends View {
	get template() {

	}

	getTemplate() {
		let template_type = this.model.get( 'template_type' ),
			current_round = this.model.get('current_round');

		if( template_type === 'streak' ) {
			return current_round < start_round_streak
				? streak_pre_season_template
				: streak_template;
		}
		else {
			return template;
		}
	}

	get className() {
		return 'empty-ladder-row';
	}

	initialize() {
		this.model = this.getOption('league');
	}
}

export default EmptyCompRowView;